import { IAsidePanelState } from '../types';

export const ASIDE_PANEL_LOCALSTORAGE = 'ASIDE_PANEL_LOCALSTORAGE';

export interface IAsidePanelLocalStorage extends IAsidePanelState {
};
